import { $store } from "..";
import StoreModule from "../core/StoreModule";
import { $layoutSource } from "../layout_source/store";
import { WizardState } from "./state";
import { ExitWizardPayload } from "./types";

class WizardStore extends StoreModule<WizardState> {
  protected state: WizardState = {
    ready: false,
    layout: {
      active: false,
      step: 1,
      uploadStep: {
        completed: false,
      },
      designStep: {
        completed: false,
        page: 1,
        selectedInsert: null,
      },
    },
  };

  get ready() {
    return this.state.ready;
  }

  set ready(val) {
    this.state.ready = val;
  }

  get layoutStep() {
    return this.state.layout.step;
  }

  set layoutStep(val: number) {
    this.setState({
      ...this.state,
      layout: { ...this.state.layout, step: val },
    });
  }

  get layoutPage() {
    return this.state.layout.designStep.page;
  }

  set layoutPage(val: number) {
    this.setState({
      ...this.state,
      layout: {
        ...this.state.layout,
        designStep: { ...this.state.layout.designStep, page: val },
      },
    });
  }

  get selectedInsert() {
    return this.state.layout.designStep.selectedInsert;
  }

  set selectedInsert(val) {
    this.setState({
      ...this.state,
      layout: {
        ...this.state.layout,
        designStep: { ...this.state.layout.designStep, selectedInsert: val },
      },
    });
  }

  get layoutActive() {
    return this.state.layout.active;
  }

  set layoutActive(val) {
    this.setState({
      ...this.state,
      layout: { ...this.state.layout, active: val },
    });
  }

  previousLayoutPage() {
    if (this.layoutPage > 1) {
      this.layoutPage--;
    }
  }

  nextLayoutPage() {
    if (
      this.layoutPage <
      ($layoutSource.layoutSource?.metadata.numberOfPages as number)
    ) {
      this.layoutPage++;
    }
  }

  exitWizard(data: ExitWizardPayload) {
    if (window.parent) {
      if ($store.wizardInstances.wizardInstance?.origins) {
        $store.wizardInstances.wizardInstance?.origins.forEach((origin) => {
          window.parent.postMessage(data, origin);
        });
      } else {
        window.parent.postMessage(data, "*");
      }
    }
  }
}

export const $wizard = StoreModule.singleton(WizardStore);
